let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("cM9em"), load("fr9NE"), load("hPzOn"), load("h2MrD"), load("bYT2S"), load("iVQTr")]).then(() => parcelRequire('8kufr'));